export default "__VITE_ASSET__daMrOX0n__"